// modules/Battle/BattleStatusManager.js
// 战斗状态效果管理模块 - 处理玩家和敌人的状态效果

import MessageHelper from '../MessageHelper.js';

export default class BattleStatusManager {
    constructor(scene, battlePlayer, battleEnemy, battleAnimation, battleLogic) {
        this.scene = scene;
        this.battlePlayer = battlePlayer;
        this.battleEnemy = battleEnemy;
        this.battleAnimation = battleAnimation;
        this.battleLogic = battleLogic;
    }
    
    /**
     * 处理玩家状态效果
     * @param {Function} onDefeat - 失败回调
     */
    processPlayerStatusEffects(onDefeat = null) {
        const player = this.battlePlayer.getPlayer();
        const damage = this.battleLogic.processStatusEffects(player);
        
        if (damage > 0) {
            // 显示状态伤害
            this.battleAnimation.showDamage(this.battlePlayer.playerSprite, damage);
            this.battlePlayer.updatePlayerHPBar();
            MessageHelper.showInfo(this.scene, `状态效果造成 ${damage} 点伤害`);
        }
        
        // 更新状态效果UI
        this.battlePlayer.updateStatusEffects();
        
        // 检查是否被击败
        if (player.hp <= 0) {
            if (onDefeat) onDefeat();
        }
    }
    
    /**
     * 处理敌人状态效果
     * @param {Function} onVictory - 胜利回调
     */
    processEnemyStatusEffects(onVictory = null) {
        const aliveEnemies = this.battleEnemy.getAliveEnemies();
        
        aliveEnemies.forEach(enemySprite => {
            const enemy = enemySprite.enemyData;
            const damage = this.battleLogic.processStatusEffects(enemy);
            
            if (damage > 0) {
                // 显示状态伤害
                this.battleAnimation.showDamage(enemySprite, damage);
                this.battleEnemy.updateEnemyHPBar(enemySprite);
                
                // 敌人受击抖动（状态效果伤害）
                this.battleAnimation.playEnemyHitShake(enemySprite, damage);
            }
            
            // 更新状态效果UI
            this.battleEnemy.updateEnemyStatusEffects(enemySprite);
            
            // 检查敌人是否被击败
            if (enemy.hp <= 0) {
                enemySprite.setVisible(false);
            }
        });
        
        // 检查战斗状态
        const battleResult = this.battleLogic.checkBattleStatus(
            this.battlePlayer.getPlayer(),
            this.battleEnemy.getAllEnemies()
        );
        
        if (battleResult === 'victory') {
            if (onVictory) onVictory();
        }
    }
}
